/* eslint-disable react-hooks/exhaustive-deps */
import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";

function TkMaterialStatusDetail ( props ) {

    const {
        
        onSelectMst,
        materialType,
        headerTitle
    } = props;

    const [api, setApi] = useState();
    
    const { t } = useTranslation ();

    useEffect(()=>{

        if ( api ) {

            api.refresh ();

        }

    },[onSelectMst?.materialName])

    const onApiInitialized = ( api ) => {

        setApi ( api );

    };

    const modifyUrl = (url)=> {
        let newUrl = (`${url}/${materialType}/${encodeURIComponent(onSelectMst?.materialName?.replaceAll(`/`,``))}`);
        return newUrl
    
    }

    return (

        <BasicCrudScreenType 
            id="TkVwMaterialStatus"
            view="TkVwMaterialStatus"
            headerTitle = {headerTitle}
            onInitialized = {(grid) => grid.selectionMode = "None"}
            onApiInitialized={onApiInitialized}
            onModifyViewUrl = {modifyUrl}
            noCreate
            noSearch
            noEdit
            noFilter
            noDelete
            noExcel
        />
    )

}

export default TkMaterialStatusDetail;
